"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMemberLabelCombo = getMemberLabelCombo;
exports.getMemberSearchCombo = getMemberSearchCombo;
exports.imageAccessDomain = imageAccessDomain;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var requestUrl = '/xyCommon';

// 获取图片访问域名
function imageAccessDomain() {
  return (0, _requestPIM.default)({
    url: requestUrl + '/imageAccessDomain',
    method: 'get'
  });
}

// 获取会员标签
function getMemberLabelCombo() {
  return (0, _requestPIM.default)({
    url: requestUrl + '/memberLevelCombo',
    method: 'get'
  });
}

// 获取会员信息
function getMemberSearchCombo(query) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/memberSearchCombo',
    method: 'get',
    params: query
  });
}